import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ProgressReportElementsDB extends GenericDB {
  constructor(progressReportId = null) {
    super('', 'progressReports.progressReportElements');
    this.setProgressReportId(progressReportId);
  }

  setProgressReportId(progressReportId) {
    this.progressReportId = progressReportId;
  }

  getCollectionRef() {
    return collection(db, 'progressReports', this.progressReportId, 'progressReportElements');
  }
}
